<template>
  <div id="chat_user_details">
      <div class="inner">
        <UserIcon size="big" :user_data="userData" :clickable="false" />
        <h3 v-text="userData.display_name"></h3>
        <div class="contact_details" v-if="!isNull(userData.artist_data)">
          <ul v-if="userData.artist_data.con2_name != ''">
            <li><label>סוכן</label><span v-text="userData.artist_data.con2_name"></span></li>
            <li v-if="!isNull(userData.artist_data.con2_email)"><label>מייל</label><span v-text="userData.artist_data.con2_email"></span></li>
            <li v-if="!isNull(userData.artist_data.con2_phone1)"><label>טלפון</label><span v-text="userData.artist_data.con2_phone1"></span></li>
          </ul>
          
          <ul v-if="userData.artist_data.con1_name != ''">
            <li><label>יחצן</label><span v-text="userData.artist_data.con1_name"></span></li>
            <li v-if="!isNull(userData.artist_data.con1_email)"><label>מייל</label><span v-text="userData.artist_data.con1_email"></span></li>
            <li v-if="!isNull(userData.artist_data.con1_phone1)"><label>טלפון</label><span v-text="userData.artist_data.con1_phone1"></span></li>
          </ul>
          
          <ul v-if="userData.artist_data.con3_name != ''">
            <li><label>בוקינג</label><span v-text="userData.artist_data.con3_name"></span></li>
            <li v-if="!isNull(userData.artist_data.con3_email)"><label>מייל</label><span v-text="userData.artist_data.con3_email"></span></li>
            <li v-if="!isNull(userData.artist_data.con3_phone1)"><label>טלפון</label><span v-text="userData.artist_data.con3_phone1"></span></li>
          </ul>
        </div>
    </div>
  </div>
</template>

<script>

import UserIcon from '../user_icon.vue';
export default {
    props: ["userData"],
    components: { UserIcon },
    data(){
        return {
        }
    },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
#chat_user_details .inner { width: 170px; margin: 0 auto;}
#chat_user_details .inner { padding-top: 40px;
    .user_icon { border-radius: 8px !important; margin: 0 auto; margin-bottom: 25px; }
    h3 { font-size: 24px; color: #343c4b; font-weight: normal; text-align: center;}
}

.contact_details { padding-top: 15px;
  ul { display: block; margin-bottom: 15px;
    li { 
      label { font-weight: bold; margin-left: 10px;}
    }
  }

}
</style>